// Posts

; (function (jQuery) {

	"use strict";

	function Posts() {

		var fn = {

			init: function ()
			{
				// Reload page on Filter Select change
				jQuery('.post-cat-selector select').on('change', fn.sendToTaxPage);
			},

			sendToTaxPage: function()
			{
				let taxPageURL = jQuery(this).val();
				window.location = taxPageURL;
			}

		}

		jQuery(fn.init);

	}

	new Posts();

})(jQuery);